module.exports = __webpack_public_path__ + "img/b960be5.png";